module.exports = __webpack_public_path__ + "back_black.945297b0.png";